import bundledGuide from './travelPlanningGuide.generated.json';

export function getTravelPlanningGuide() {
  // The server snapshot keeps HTML and React identical across separate deployments.
  if (typeof document !== 'undefined') {
    try {
      const content = JSON.parse(document.getElementById('trackme-planning-guide-data')?.textContent || 'null');
      if (content?.path === bundledGuide.path && Array.isArray(content.sections) && content.template && content.example && Array.isArray(content.faq)) {
        return content;
      }
    } catch { /* Client navigation and the development server use the bundled copy. */ }
  }
  return bundledGuide;
}

export function getPlanningGuideTemplate(guide = getTravelPlanningGuide()) {
  return [guide.template.columns, ...guide.template.rows].map(row => row.join('\t')).join('\n');
}

export function getPlanningGuideJsonLd(guide = getTravelPlanningGuide()) {
  const url = `https://trackme.su${guide.path}`;
  return [
    {
      '@context': 'https://schema.org', '@type': 'Article', '@id': `${url}#article`,
      headline: guide.h1, name: guide.h1, description: guide.description, url,
      inLanguage: 'ru-RU', dateModified: guide.dateModified,
      author: { '@type': 'Organization', name: guide.author, url: 'https://trackme.su/o-trackme/' },
      publisher: { '@type': 'Organization', name: 'TrackMe', url: 'https://trackme.su/' },
      image: guide.screenshots.items.map(item => item.src),
      mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    },
    {
      '@context': 'https://schema.org', '@type': 'BreadcrumbList', '@id': `${url}#breadcrumbs`,
      itemListElement: [
        { name: 'Главная', path: '/' },
        { name: 'Планирование путешествий', path: '/planirovanie-puteshestviy/' },
        { name: guide.h1, path: guide.path },
      ].map((item, index) => ({ '@type': 'ListItem', position: index + 1, name: item.name, item: `https://trackme.su${item.path}` })),
    },
    {
      '@context': 'https://schema.org', '@type': 'FAQPage', '@id': `${url}#faq`,
      mainEntity: guide.faq.map(item => ({ '@type': 'Question', name: item.question, acceptedAnswer: { '@type': 'Answer', text: item.answer } })),
    },
  ];
}
